import { FeatureFlags as CatalogFeatureFlags } from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';
import { FeatureFlags as VizportalClientFeatureFlags } from '../ts/FeatureFlags';

// This object is lazy-loaded because the feature flags aren't fully set up until after the app login
export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    catalogSevereWarningsEnabled: VizportalClientFeatureFlags.catalogSevereWarningsEnabled,
    catalogTagsEnabled: VizportalClientFeatureFlags.catalogTagsEnabled,
  };
});
